import * as tslib_1 from "tslib";
import { toFileWithPath } from './file';
var FILES_TO_IGNORE = ['.DS_Store', 'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */

export function fromEvent(evt) {
  return tslib_1.__awaiter(this, void 0, void 0, function () {
    var dt;
    return tslib_1.__generator(this, function (_a) {
      if (isDragEvt(evt)) {
        dt = evt.dataTransfer;

        if (dt.items && dt.items.length) {
          return [2
          /*return*/
          , getDataTransferFiles(dt, evt.type)];
        } else if (dt.files && dt.files.length) {
          return [2
          /*return*/
          , fromFileList(dt.files)];
        }
      } else if (evt.target instanceof HTMLInputElement && evt.target.files && evt.target.files) {
        return [2
        /*return*/
        , fromFileList(evt.target.files)];
      }

      return [2
      /*return*/
      , []];
    });
  });
}

function isDragEvt(value) {
  return !!value.dataTransfer;
}

function getDataTransferFiles(dt, type) {
  return tslib_1.__awaiter(this, void 0, void 0, function () {
    var items, files;
    return tslib_1.__generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          items = Array.from(dt.items).filter(function (item) {
            return item.kind === 'file';
          });
          if (!(type === 'drop')) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , Promise.all(items.map(function (item) {
            return toFilePromises(item);
          }))];

        case 1:
          files = _a.sent();
          return [2
          /*return*/
          , flatten(files).filter(function (file) {
            return !FILES_TO_IGNORE.includes(file.name);
          })];

        case 2:
          return [2
          /*return*/
          , items];
      }
    });
  });
} // https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem


function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry !== 'function') {
    return fromDataTransferItem(item);
  }

  var entry = item.webkitGetAsEntry();

  if (entry) {
    return fromEntry(entry);
  }

  return [];
}

function flatten(items) {
  return items.reduce(function (acc, files) {
    return tslib_1.__spread(acc, Array.isArray(files) ? flatten(files) : [files]);
  }, []);
}

function fromFileList(fileList) {
  return Array.from(fileList).map(function (file) {
    return toFileWithPath(file);
  });
}

function fromDataTransferItem(item) {
  var file = item.getAsFile();
  var fwp = toFileWithPath(file);
  return Promise.resolve(fwp);
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry


function fromEntry(entry) {
  return tslib_1.__awaiter(this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
      if (entry.isDirectory) {
        return [2
        /*return*/
        , fromDirEntry(entry)];
      } else {
        return [2
        /*return*/
        , fromFileEntry(entry)];
      }

      return [2
      /*return*/
      ];
    });
  });
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry


function fromDirEntry(entry) {
  var reader = entry.createReader();
  return new Promise(function (resolve) {
    var entries = [];

    function readEntries() {
      // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
      // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
      reader.readEntries(function (batch) {
        if (!batch.length) {
          // Done reading directory
          resolve(Promise.all(entries));
        } else {
          var items = Promise.all(batch.map(fromEntry));
          entries.push(items); // Continue reading

          readEntries();
        }
      }, noop);
    }

    readEntries();
  });
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry


function fromFileEntry(entry) {
  return tslib_1.__awaiter(this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
      return [2
      /*return*/
      , new Promise(function (resolve) {
        entry.file(function (file) {
          var fwp = toFileWithPath(file, entry.fullPath);
          resolve(fwp);
        });
      })];
    });
  });
} // tslint:disable-next-line: no-empty


function noop() {}